module.exports = __webpack_public_path__ + "media/images/event/image_04-0a0b0aac713c3b2e7389b5bff573855f.png";